import { child, get, set, getDatabase, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../index.css";
import ErrorMessage from "./ErrorMessage";
import { FaRegThumbsUp } from "react-icons/fa";

function Gallery(props) {
  return (
    <div className="d-flex col">
      <div className="gallery">
        {" "}
        <img
          src={props.space.image}
          alt={props.space.title}
          className="w-100"
        />
      </div>
    </div>
  );
}

function RentDesc(props) {
  const [clientThumb, setClientThumb] = useState(props.space.thumbs);
  const [isDisabled, setDisabled] = useState(false);
  const [buttonType, setButtonType] = useState("like-btn btn-secondary");
  return (
    <div className="desc p-4 border">
      <button
        className={buttonType}
        onClick={() => {
          if (!isDisabled) {
            props.callback(props.space.thumbs);
            setClientThumb(clientThumb + 1);
            setButtonType("like-btn btn-primary");
            setDisabled(true);
          }
        }}
      >
        <FaRegThumbsUp size={28} />
        {clientThumb}
      </button>
      <h1>{props.space.title}</h1>
      <p>{props.space.description} </p>
      <div className="descbtn">
        <Link to={"/profile/" + props.uid}>
          <div className="btn profile-btn" role="button">
            View Profile
          </div>
        </Link>
      </div>
    </div>
  );
}

function RentInfo(props) {
  return (
    <div className="toRent bg-light border">
      <div className="rentInfo">
        <img src="/img/logowname.png" alt="logo" />
        <h2>${props.info.space.price} per hour</h2>
        <div className="rentbttn">
          <a rel="noreferrer" href={props.info.calendly} target="_blank">Rent</a>
        </div>
        <p>
          After scheduling communication and payment is done off of the website.
        </p>
      </div>
    </div>
  );
}

export default function Rent() {
  let uid = useParams().uid;

  const [currentSpace, setSpace] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const db = getDatabase();
    get(child(ref(db), "/users"))
      .then((snapshot) => snapshot.val())
      .then((users) => {
        const user = users[uid];
        if (!user) {
          setErrorMessage("We couldn't find this user.");
        } else {
          setSpace(user);
        }
      })
      .catch((error) => {
        setErrorMessage(error.message);
      });
  }, [uid]);

  if (!errorMessage && !currentSpace) {
    return (
      <main>
        <h1>Loading...</h1>
      </main>
    );
  }

  function thumbUp(current) {
    const db = getDatabase();
    set(ref(db, "users/" + uid + "/space/thumbs"), current + 1);
  }

  return (
    <main className="rentMain">
      {errorMessage ? (
        <ErrorMessage errorMessage={errorMessage} />
      ) : (
        <div>
          <Gallery space={currentSpace.space} />
          <div className="rentInformation">
            <RentDesc space={currentSpace.space} uid={uid} callback={thumbUp} />
            <RentInfo info={currentSpace} />
          </div>
        </div>
      )}
    </main>
  );
}
